import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BackgroundTasksComponent } from './background-tasks.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BackgroundTasksComponent],
  imports: [ProgressSpinnerModule, CommonModule, FormsModule, TranslateModule],
  exports: [BackgroundTasksComponent],
})
export class BackgroundTasksModule {}
